import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  fetchProfiles,
  fetchProfile,
  updateTitle,
  savePerfil,
  removePerfil
} from './../../actions'
import TextField from 'material-ui/TextField'
import Subheader from 'material-ui/Subheader'
import { List, ListItem } from 'material-ui/List'
import Avatar from 'material-ui/Avatar'
import More from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import AccountCircle from 'material-ui/svg-icons/action/face'
import RaisedButton from 'material-ui/RaisedButton'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { GridList, GridTile } from 'material-ui/GridList'
import Snackbar from 'material-ui/Snackbar'

class ProfileIndexContainer extends Component {
  state = {
    master: true,
    detail: false,
    profile: null,
    errorMessageName: null,
    errorMessagePin: null,
    errorMessageCode: null,
    deleteDialogOpen: false,
    successMessage: '',
    processing: false
  }

  constructor(props) {
    super(props)
    this.profileName = null
    this.profilePin = null
    this.profileCode = null
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.detail === true) {
      this.props.actions.updateTitle({
        label: 'Volver',
        back: true,
        action: () => {
          this.setState({
            profile: null,
            master: true,
            detail: false,
            errorMessageName: null,
            errorMessagePin: null,
            errorMessageCode: null
          })

          this.props.actions.updateTitle({
            label: 'Ebooks Patagonia',
            back: false,
            action: () => {}
          })
        }
      })
    }
  }

  componentDidMount() {
    this.props.actions.fetchProfiles(this.props.user)
    this.props.actions.updateTitle({
      label: 'Ebooks Patagonia',
      back: false,
      action: () => {}
    })
  }

  handleRemove() {
    this.props.actions.removePerfil(this.state.profile, this.props.user)

    this.setState({
      profile: null,
      master: true,
      detail: false,
      errorMessageName: null,
      errorMessagePin: null,
      errorMessageCode: null
    })

    this.props.actions.updateTitle({
      label: 'Ebooks Patagonia',
      back: false,
      action: () => {}
    })
  }

  handleSave() {
    this.setState({
      errorMessageName: null,
      errorMessagePin: null,
      errorMessageCode: null,
      processing: true
    })

    if (this.profileName.input.value.length < 3) {
      this.setState({
        errorMessageName: 'Debes ingresar un nombre para el perfil.',
        processing: false
      })
      return
    }

    if (this.profileName.input.value === undefined) {
      this.setState({
        errorMessageName: 'Debes ingresar un nombre para el perfil.',
        processing: false
      })
      return
    }

    if (
      this.profilePin.input.value.length < 4 ||
      this.profilePin.input.value.length > 10
    ) {
      this.setState({
        errorMessagePin:
          'Debes ingresar una clave de lector de largo mínimo 4 y máximo 10.',
        processing: false
      })
      return
    }

    if (this.profilePin.input.value === undefined) {
      this.setState({
        errorMessagePin:
          'Debes ingresar una clave de lector de largo mínimo 4 y máximo 10.',
        processing: false
      })
      return
    }

    if (this.state.errorMessageName !== null) return
    if (this.state.errorMessagePin !== null) return
    if (this.state.errorMessageCode !== null) return

    this.props.actions.savePerfil(
      {
        key: this.state.profile === null ? -1 : this.state.profile.key,
        name: this.profileName.input.value,
        password: this.profilePin.input.value,
        code: this.profileCode.input.value,
        profile: this.state.profile
      },
      this.props.user,
      {
        success: (profile, successMessage) => {
          //Cuando se trata de un perfil se actualiza el valor devuelto - si es el mismo no pasa nada, es inmutable
          this.setState({
            profile: profile,
            master: false,
            detail: true,
            errorMessageName: null,
            errorMessagePin: null,
            errorMessageCode: null,
            successMessage: successMessage,
            processing: false
          })

          this.profileCode.input.value = ''
        },
        error: error => {
          this.setState(error)
          this.setState(
            Object.assign({}, error, {
              processing: false
            })
          )
        }
      }
    ) //End save perfil
  }

  render() {
    const items =
      Object.keys(this.props.profiles).length === 0
        ? []
        : Object.keys(this.props.profiles).map(key => {
            return this.props.profiles[key]
          })

    const add = (
      <FloatingActionButton
        secondary={false}
        className="right"
        backgroundColor="red"
        style={{
          marginRight: 20
        }}
        onTouchTap={() => {
          this.setState({
            profile: null,
            master: false,
            detail: true
          })
        }}
      >
        <ContentAdd />
      </FloatingActionButton>
    )

    const deleteDialogActions = [
      <FlatButton
        label="Cancelar"
        primary={true}
        onTouchTap={() => {
          this.setState({
            deleteDialogOpen: false
          })
        }}
      />,
      <FlatButton
        label="Borrar Perfil"
        primary={true}
        keyboardFocused={true}
        onTouchTap={() => {
          this.handleRemove()
          this.setState({
            deleteDialogOpen: false,
            successMessage: 'El perfil se ha borrado.'
          })
        }}
      />
    ]

    const list = (
      <List>
        {items.map(item => {
          return (
            <ListItem
              key={item.key}
              leftAvatar={<Avatar icon={<AccountCircle />} />}
              rightIcon={<More />}
              primaryText={item.name}
              secondaryText={
                (item.books === undefined
                  ? ''
                  : Object.keys(item.books).length + ' libros, ') +
                'Contraseña de perfil: ' +
                item.password
              }
              onTouchTap={() => {
                this.setState({
                  profile: item,
                  master: false,
                  detail: true,
                  successMessage: ''
                })
              }}
            />
          )
        })}
      </List>
    )

    const books =
      this.state.profile === null
        ? []
        : this.state.profile.books === undefined
          ? []
          : Object.keys(this.state.profile.books).map(key => {
              return key
            })

    const booksGridStyles = {
      root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
      },
      gridList: {
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto'
      },
      titleStyle: {
        color: 'rgb(0, 188, 212)'
      }
    }

    const booksGrid = (
      <div style={booksGridStyles.root}>
        <GridList style={booksGridStyles.gridList} cols={2.2}>
          {books.map(key =>
            <GridTile
              key={key}
              title={null}
              titleStyle={booksGridStyles.titleStyle}
              titleBackground="linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
            >
              <img
                src={
                  'https://eltigre.imgix.net/' +
                  key.replace('_', '') +
                  '_cover.jpg?w=200&h=150&dpr=' +
                  window.devicePixelRatio
                }
              />
            </GridTile>
          )}
        </GridList>
      </div>
    )

    const detail = (
      <form className="content">
        <TextField
          tabIndex={1}
          ref={input => (this.profileName = input)}
          id="profile"
          fullWidth={true}
          floatingLabelText="Perfil Lector"
          errorText={this.state.errorMessageName}
          defaultValue={
            this.state.profile === null ? '' : this.state.profile.name
          }
        />
        <TextField
          tabIndex={2}
          ref={input => (this.profilePin = input)}
          id="password"
          fullWidth={true}
          maxLength={10}
          floatingLabelText="Contraseña de perfil"
          errorText={this.state.errorMessagePin}
          defaultValue={
            this.state.profile === null ? '' : this.state.profile.password
          }
        />
        <TextField
          tabIndex={3}
          ref={input => (this.profileCode = input)}
          id="code"
          fullWidth={true}
          floatingLabelText="Código de activación de plan lector"
          errorText={this.state.errorMessageCode}
        />
        <br />
        {books.length > 0 &&
          <Subheader>
            {books.length} libros disponibles
          </Subheader>}
        {booksGrid}
        <br />
        {this.state.profile !== null &&
          <RaisedButton
            tabIndex={4}
            className="left"
            label={'Borrar Perfil'}
            secondary={false}
            onTouchTap={() => {
              this.setState({
                deleteDialogOpen: true
              })
            }}
          />}
        <RaisedButton
          tabIndex={4}
          className="right"
          disabled={this.state.processing}
          label={this.state.processing ? 'Guardando ...' : 'Guardar'}
          secondary={true}
          onTouchTap={() => {
            this.handleSave()
          }}
        />
        <Dialog
          title="Atención"
          actions={deleteDialogActions}
          modal={true}
          open={this.state.deleteDialogOpen}
        >
          ¿Está seguro que quieres borrar este perfil?
        </Dialog>
        <Snackbar
          open={this.state.successMessage.length > 0}
          message={this.state.successMessage}
          action={null}
          autoHideDuration={3000}
          onActionTouchTap={null}
          onRequestClose={() => {
            this.setState({
              successMessage: ''
            })
          }}
        />
      </form>
    )

    return (
      <div>
        {this.state.master &&
          <div className="master">
            <br />
            <h2 className="container">Tus Perfiles de Lector</h2>
            {list}
            {add}
          </div>}
        {this.state.detail &&
          <div className="detail container">
            {detail}
          </div>}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    profiles: state.profiles,
    user: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { fetchProfiles, fetchProfile, updateTitle, savePerfil, removePerfil },
      dispatch
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  ProfileIndexContainer
)



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileIndexContainer.js